<div
  mat-ripple
  (click)="fnItem(cardContent.card_id)"
  fxLayout="row"
  fxLayoutAlign="space-between stretch"
  style="
    margin-bottom: 0.5em;
    border: solid 1px #ddd;
    padding: 0.5em;
    background-color: #fff;
  "
>
  <div fxFlex="15" style="display: flex; align-items: center">
    <img
      *ngIf="cardContent.card_image_url"
      style="margin-bottom: -6.5px; max-height: 120px; width: 100%"
      src="{{ cardContent.card_image_url }}"
    />

    <img
      *ngIf="!cardContent.card_image_url"
      style="margin-bottom: -6.5px; max-height: 120px; width: 100%"
      src="https://wikipapa.org/images/img-no-disponible-large.jpg"
    />
  </div>

  <div fxFlex="30" style="padding: 1em; display: flex; align-items: center">
    <div>
      <span style="font-weight: 500"> {{ cardContent.card_name }}</span
      ><br />
      <span>
        {{ cardContent.card_value_1 }}
      </span>
    </div>
  </div>

  <div fxFlex="15" style="padding: 1em; display: flex; align-items: center">
    <mat-icon style="color: #8b2f00">account_circle</mat-icon>

    <span>{{ cardContent.card_username }}</span>
  </div>

  <div fxFlex="20" style="padding: 1em; display: flex; align-items: center">
    <div>
      <span>{{ cardContent.card_date?.substring(0, 10) }}</span
      ><br />
      <span style="font-size: 0.8em">
        {{ time_ago(cardContent.card_date) }}</span
      >
    </div>
  </div>

  <div fxFlex="20" style="padding: 1em; display: flex; align-items: center">
    <mat-icon style="color: #8b2f00">place</mat-icon>
    <span>{{ cardContent.card_value_2 }}</span>
  </div>
</div>
